import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { balanceKeys } from '@shared/stores/balance.keys';
import { QueryClient } from '@tanstack/angular-query-experimental';

/**
 * Escrituras del propio usuario que mueven el saldo del Wallet (las seis fuentes de
 * `WalletStatementService::balance()` en el API): recargas, boletos (compra, canje, cancelación,
 * escaneo), paquetes (compra y cancelación), suscripciones (pago y cambio de horario) y reservas
 * del circuito (reserva, venta a bordo y cancelación). Cada ruta cubre también sus subrutas.
 */
export const WALLET_ENDPOINTS = [
  'pay_balance',
  'bustickets',
  'busticket_packages',
  'suscription-radial-payments',
  'circuit/reservations',
];

/**
 * Invalida el saldo al terminar cualquiera de esas escrituras, salga bien o mal: un timeout no
 * prueba que el cobro no se hizo. El API invalida su micro-caché del saldo en cada escritura del
 * usuario (`apimc.bump`), así que la relectura ya trae el saldo nuevo. Va antes de
 * `timeoutInterceptor` para invalidar una sola vez, después de sus reintentos.
 */
export const walletBalanceInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method === 'GET' || !request.url.startsWith(environment.apiBaseUrl)) {
    return next(request);
  }

  const path = request.url.slice(environment.apiBaseUrl.length).split('?')[0];
  if (!WALLET_ENDPOINTS.some((endpoint) => path === endpoint || path.startsWith(endpoint + '/'))) {
    return next(request);
  }

  const queryClient = inject(QueryClient);
  return next(request).pipe(finalize(() => void queryClient.invalidateQueries({ queryKey: balanceKeys.all })));
};
